import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { environment } from './environments/environment';
if (environment.production) {
  window.console.log = () => { };
  window.console.error = () => { };
  window.console.warn = () => { };
  window.console.info = () => { };
}
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
registerLocaleData(localeFr);
